import React from 'react'
import '../App.css';
import { Link } from 'react-router-dom'
import { Badge } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { clearImpersonationState } from '../utils/impersonation';



function Bodyheaderloged(props){
    const navigate = useNavigate();
    const LogOut = (e) =>
    {
        clearImpersonationState()
        window.localStorage.removeItem('MY_APP_STATE_USER')
        window.localStorage.removeItem('MY_APP_STATE_APIKEY')
        window.localStorage.removeItem('MY_APP_STATE_AUTHCODE')
        window.localStorage.removeItem('MY_APP_STATE_ROLE')
        window.localStorage.removeItem('MY_APP_STATE_PROF_NAME')
        window.localStorage.removeItem('MY_APP_STATE_PROF_PROF')
        window.localStorage.removeItem('MY_APP_STATE_PROV_VALOR')
        window.localStorage.removeItem('MY_APP_STATE_PROFILE')
        window.localStorage.removeItem('MY_APP_STATE_BOLETA')
        window.localStorage.removeItem('MY_APP_STATE_PROF_CASINO')
        window.localStorage.removeItem('MY_APP_STATE_PROF_ID')
        window.localStorage.removeItem('MY_APP_STATE_PROF_CASINO_ID')
        window.localStorage.removeItem('MY_APP_STATE_PROF_TIENE_IMPRESORA')
        window.localStorage.removeItem('MY_APP_STATE_PROF_IMPRESORA')
        navigate('/') 
    }
    
    return (

<div className="w-full flex justify-end mr-8">
    <h5>
        <a href='#'>
        <Badge 
            onClick={LogOut} 
            className="px-8 py-3 bg-[#5f2b41] text-white font-semibold text-lg rounded-lg shadow-lg hover:bg-[#7a3d56] focus:outline-none focus:ring-4 focus:ring-[#5f2b41] transition duration-300 ease-in-out"
        >
             Salir
        </Badge>
        </a>
    </h5>
</div>
    )    
}
export default Bodyheaderloged
